import {
    WELCOME_MODAL_OPEN,
    WELCOME_MODAL_CLOSE
  } from '../actions/modalsActions';
  
  const initialState = {
    welcomeModalIsOpen: false
  };
  
  export default function (state = initialState, action) {
    switch (action.type) {
      case WELCOME_MODAL_OPEN:
        return { ...state, welcomeModalIsOpen: true };
        case WELCOME_MODAL_CLOSE:
        return { ...state, welcomeModalIsOpen: false };
      default:
        return state;
    }
  }
  